export interface IHLineProps {
  color?: string;
}

export const HLine = ({ color }: IHLineProps) => (
  <hr
    style={{
      display: "flex",
      flex: 1,
      border: "none",
      color: color,
      margin: "0px",
      flexShrink: 0,
      backgroundColor: color,
      minHeight:'1px'
    }}
  />
);
